import { createStore } from 'redux';
import ItemReducers from '../Reducers/ItemReducers';

const store = createStore(ItemReducers);

export default store;